module.exports = __webpack_public_path__ + "static/img/animales_40.80a8fbf9.png";